let isReady = document.readyState === "complete"
    || document.readyState === "interactive";
const waiter: (() => void)[] = [];
const hangleReadyStateChange = (e: Event) => {
    if (document.readyState === "complete"
        || document.readyState === "interactive"
    ) {
        isReady = true;

        document.removeEventListener("readystatechange", hangleReadyStateChange);

        for (const callback of waiter) {
            callback();
        }
        waiter.slice(0);
    }
}
document.addEventListener("readystatechange", hangleReadyStateChange);

export const ready = (callback: () => void) => {
    if (isReady) {
        callback();
    } else {
        waiter.push(callback);
    }
};